<template>
  <div class="index">
    <div class="license columns is-multiline">
      <LicenseItem v-for="item in licenseData" :key="item.id" :license="item" />
    </div>
    <div class="centered">
      <span class="button-wrapper" @click="handleAddLicense">
        <a class="button is-info">+</a> Добавить лицензию
      </span>
    </div>
  </div>
</template>

<script>
import LicenseItem from 'components/Documents/LicenseItem'
import { mapState, mapActions } from 'vuex'
import deepcopy from 'deepcopy'
import uuidv4 from 'uuid/v4'

export default {
  name: 'License',
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['license']),
    licenseData () {
      return deepcopy(this.license)
    }
  },
  created () {
    this.getLicense()
  },
  methods: {
    ...mapActions(['getLicense', 'addLicense', 'deleteLicense', 'loadLicensePhoto', 'deleteLicensePhoto']),
    handleAddLicense () {
      this.addLicense({
        id: uuidv4(),
        title: '',
        description: '',
        photo: ''
      })
    }
  },
  components: { LicenseItem }
}
</script>

<style scoped>
.license {
  max-width: 1600px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// License.vue?15141e12